// スタンプの初期配置サイズを、そのときのキャンバス拡大率から決める純関数。
// 図形の w / h はステージ座標で保存し、画面には zoom 倍で描かれるため、
// 「画面上の見かけの大きさ」を一定に保つにはステージ座標側を zoom で割る必要がある。
// これは記憶したサイズが無いときの既定サイズで、手でリサイズした大きさを記憶した後の新規配置は、
// その大きさを下限・上限（STAMP_PLACEMENT_MIN_PX〜STAMP_PLACEMENT_MAX_PX の正方形）へ丸めた
// ステージ座標の大きさを使う（種類ごとの配置サイズの記憶。placement-size-preference.ts）。

/** 画面上で狙う見かけの大きさ（px）。拡大率 100% のときのステージ座標の大きさと一致する。 */
export const STAMP_TARGET_SCREEN_PX = 48;

/**
 * 安全弁の下限（ステージ座標 px）。これより小さいと、拡大率を 100% へ戻したときに
 * 点にしか見えず、選択・移動が難しくなる。
 */
export const STAMP_PLACEMENT_MIN_PX = 8;

/**
 * 安全弁の上限（ステージ座標 px）。最小サイズのキャンバスの短辺よりも十分小さく、
 * 拡大率を戻したときに画面を覆わない大きさに抑える。
 */
export const STAMP_PLACEMENT_MAX_PX = 512;

/**
 * そのときの拡大率から、スタンプの初期配置サイズ（ステージ座標 px）を求める。
 * 画面上の見かけを一定に保つため zoom で割り、整数へ丸めてから安全弁で抑える。
 * zoom が非有限・0 以下のときは拡大率 100% とみなす。
 */
export function resolveStampPlacementSize(zoom: number): number {
  const effectiveZoom = Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
  const raw = Math.round(STAMP_TARGET_SCREEN_PX / effectiveZoom);
  return Math.min(STAMP_PLACEMENT_MAX_PX, Math.max(STAMP_PLACEMENT_MIN_PX, raw));
}
